export const ContextEnum = {
  LayerLocalesClient: 'Camada Áreas Cliente',
  AreaStore: 'Camada Áreas de Lojas',
  LayerCustomer: 'Camada Clientes (Consumidor)',
  LayerClusterSales: 'Camada Cluster de Vendas',
  LayerDncFlexible: 'Camada DNC Flexível',
  LayerGreenfield: 'Camada Greenfield',
  LayerBrownfield: 'Camada Brownfield',
  LayerLocales: 'Camada Limites Territoriais',
  LayerInactiveStore: 'Camada Lojas Inativas',
  LayerPlannedStore: 'Camada Lojas Planejadas',
  LayerTolls: 'Camada Pedágios',
  LayerPgts: 'Camada PGTS',
  LayerPointInterest: 'Camada Pontos de Interesse',
  LayerFuel: 'Camada Postos de Abastecimento',
  LayerNetwork: 'Camada Rede',
  LayerCompetitors: 'Camada Rede Concorrentes',
  LayerDirectSale: 'Camada Venda Direta',

  // After Sales
  LayerNetworkAfterSales: 'Camada AfterSales',
  LayerInactiveStoreAfterSales: 'Camada Lojas Inativas',
  LayerCustomersAfterSales: 'Camada CustomersAfterSales',
  LayerStoreAreasAfterSales: 'Camada Área de lojas AfterSales',
  LayerMarkedAreaAfterSales: 'Camada Área AfterSales',
  LayerGreenfieldAfterSales: 'Camada Greenfield AfterSales',
  LayerSelectedAreasAfterSales: 'Camada Limites Territoriais AfterSales',
  LayerCompetitorsAfterSales: 'Camada Limites Territoriais AfterSales',
  // After Sales

  LayerVoronoi: 'Camada Voronoi',
  DncFlexible: 'DNC Flexível',
  SelectTool: 'Ferramenta de Seleção',
  StoreInfo: 'Ficha da Loja',
  PanelSuperior: 'Painel Superior',
  PinStore: 'PIN Concessionária',
  PinGreenfield: 'PIN Greenfield',
  PinPointInterest: 'PIN Ponto de Interesse',
  Report: 'Report',
  ReportBpa: 'Report - Business Plan',
  Routes: 'Rotas',
  Summary: 'Summary',
  Tema: 'Tema',
  LocaleType: 'Tipo Localidade',
  LocaleTypeClient: 'Tipo Localidade Cliente'
};



// WEBPACK FOOTER //
// ./src/enuns/context.enum.js